<template>
    <div class="page" :style="style"></div>
</template>

<script>
export default {
    name: 'FullPageBackground',
    props: ['url'],
    computed: {
        style() {
            let url = this.url;
            if (!url.startsWith('/')) {
                url = `/img/guidance/${this.url}`;
            }
            return `background-image: url('${url}')`;
        }
    },
}
</script>

<style scoped>
.page {
    height: 100%;
    background-repeat: no-repeat;
    background-size: cover;
}
</style>
